import { ValidationMesssageModel } from "../ValidationMesssage";
import { ValidatorModel } from "../Validator";

export const RequiredObjectValidatorModel = ValidatorModel.actions((self) => {
  return {
    validate(value: any) {
      if (value && value["id"]) return undefined;

      return ValidationMesssageModel.create({
        message: { mainKey: "general.validation.required" },
      });
    },
  };
});
